import React from "react";

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import UpdatePassword from "./UpdatePassword";
import MyProfile from "./MyProfile";
import EditProfile from "./EditProfile";
import "assets/scss/styles.css";

class UserProfile extends React.Component {
  render() {
    return (
      <GridContainer justify="center" className="gridContainerMargin90">
        <GridItem xs={12} sm={8}>
          <Wizard
            steps={[
              { stepName: "About", stepComponent: MyProfile, stepId: "about" },
              {
                stepName: "Edit Profile",
                stepComponent: EditProfile,
                stepId: "editProfile"
              }
              // {
              //   stepName: "Update Password",
              //   stepComponent: UpdatePassword,
              //   stepId: "updatePassword"
              // }
            ]}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/User/UserProfile.jsx